import { createClient } from 'laboratory-lib';
import PortalIdParser from 'PortalIdParser';
import experiments from '../../experiments.yaml';
export const laboratoryClient = createClient({
  name: 'purchase-motions-laboratory-client',
  experiments: experiments,
  identifiers: {
    portalId: PortalIdParser.get()
  }
});

// v3's client exposes a callback-based `resolve(cb)` that returns void, so we
// derive the treatments shape from that callback and wrap it in a Promise for
// consumers. An empty experiments map resolves immediately with `{}`.
export const resolveTreatments = () => new Promise(resolve => laboratoryClient.resolve(resolve));